import { render, staticRenderFns } from "./paper-result-exam.vue?vue&type=template&id=55a10a22&scoped=true"
import script from "./paper-result-exam.vue?vue&type=script&lang=ts"
export * from "./paper-result-exam.vue?vue&type=script&lang=ts"
import style0 from "./paper-result-exam.vue?vue&type=style&index=0&id=55a10a22&prod&lang=scss&scoped=true"
import style1 from "./paper-result-exam.vue?vue&type=style&index=1&id=55a10a22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a10a22",
  null
  
)

export default component.exports